module.exports = __webpack_public_path__ + "5a798b089058fa4d6e7c60ad5f1a22be.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-11.png
// module id = 2036
// module chunks = 0